function OpenCartDr(){
$(".drawer").toggleClass("active");
}

function openNav() {
          document.getElementById("mySidebar").style.left = "0px";
          document.getElementById("sidebar_container_blur_bg").style.right = "-5vw";
        }  
        function closeNav() {
          document.getElementById("mySidebar").style.left = "-100vw"; 
          document.getElementById("sidebar_container_blur_bg").style.right = "-105vw";
          }

           function handleMousePos(event) {
      var mouseClickWidth = event.clientX;
      if(mouseClickWidth>=280){
            document.getElementById("mySidebar").style.left = "-100vw";
            document.getElementById("sidebar_container_blur_bg").style.right = "-105vw";
           }
}

document.addEventListener("click", handleMousePos);



$('.feature_collection_container').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  prevArrow:'<svg class="arrow1" viewBox="0 0 28 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M28 9C28 8.73482 27.8947 8.4805 27.7071 8.29299C27.5196 8.10548 27.2653 8.00014 27.0001 8.00014H3.41557L9.70917 1.70902C9.80214 1.61606 9.87589 1.5057 9.9262 1.38424C9.97652 1.26277 10.0024 1.13259 10.0024 1.00112C10.0024 0.869653 9.97652 0.739471 9.9262 0.61801C9.87589 0.496548 9.80214 0.386185 9.70917 0.293222C9.6162 0.200259 9.50583 0.126517 9.38436 0.076206C9.26288 0.0258949 9.13269 0 9.00121 0C8.86973 0 8.73954 0.0258949 8.61807 0.076206C8.4966 0.126517 8.38623 0.200259 8.29326 0.293222L0.293769 8.2921C0.200648 8.38498 0.126767 8.49531 0.0763576 8.61679C0.0259479 8.73826 0 8.86848 0 9C0 9.13152 0.0259479 9.26174 0.0763576 9.38321C0.126767 9.50469 0.200648 9.61502 0.293769 9.7079L8.29326 17.7068C8.38623 17.7997 8.4966 17.8735 8.61807 17.9238C8.73954 17.9741 8.86973 18 9.00121 18C9.13269 18 9.26288 17.9741 9.38436 17.9238C9.50583 17.8735 9.6162 17.7997 9.70917 17.7068C9.80214 17.6138 9.87589 17.5035 9.9262 17.382C9.97652 17.2605 10.0024 17.1303 10.0024 16.9989C10.0024 16.8674 9.97652 16.7372 9.9262 16.6158C9.87589 16.4943 9.80214 16.3839 9.70917 16.291L3.41557 9.99986H27.0001C27.2653 9.99986 27.5196 9.89452 27.7071 9.70701C27.8947 9.5195 28 9.26518 28 9Z" fill="#DADADA"/></svg>',
  nextArrow:'<svg class="arrow2" viewBox="0 0 28 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M-1.90735e-06 9C-1.90735e-06 8.73482 0.105349 8.4805 0.292873 8.29299C0.480396 8.10548 0.734735 8.00014 0.999935 8.00014H24.5844L18.2908 1.70902C18.1979 1.61606 18.1241 1.5057 18.0738 1.38424C18.0235 1.26277 17.9976 1.13259 17.9976 1.00112C17.9976 0.869653 18.0235 0.739471 18.0738 0.61801C18.1241 0.496548 18.1979 0.386185 18.2908 0.293222C18.3838 0.200259 18.4942 0.126517 18.6156 0.076206C18.7371 0.0258949 18.8673 0 18.9988 0C19.1303 0 19.2605 0.0258949 19.3819 0.076206C19.5034 0.126517 19.6138 0.200259 19.7067 0.293222L27.7062 8.2921C27.7994 8.38498 27.8732 8.49531 27.9236 8.61679C27.9741 8.73826 28 8.86848 28 9C28 9.13152 27.9741 9.26174 27.9236 9.38321C27.8732 9.50469 27.7994 9.61502 27.7062 9.7079L19.7067 17.7068C19.6138 17.7997 19.5034 17.8735 19.3819 17.9238C19.2605 17.9741 19.1303 18 18.9988 18C18.8673 18 18.7371 17.9741 18.6156 17.9238C18.4942 17.8735 18.3838 17.7997 18.2908 17.7068C18.1979 17.6138 18.1241 17.5035 18.0738 17.382C18.0235 17.2605 17.9976 17.1303 17.9976 16.9989C17.9976 16.8674 18.0235 16.7372 18.0738 16.6158C18.1241 16.4943 18.1979 16.3839 18.2908 16.291L24.5844 9.99986H0.999935C0.734735 9.99986 0.480396 9.89452 0.292873 9.70701C0.105349 9.5195 -1.90735e-06 9.26518 -1.90735e-06 9Z" fill="#979797"/></svg>',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});


$('.sec5_home_inner_left_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  centerMode: true,
  centerPadding: '120px',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        centerPadding: '80px'
      }
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
        centerPadding: '30px'
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        centerPadding: '50px'
      }
    }
  ]
});



$('.sec6_home_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
});

$('.sec7_home').slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  variableWidth: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 2000,
  cssEase: 'linear'
});


$('.offer_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  variableWidth: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 7000,
  cssEase: 'linear'
});


$('.sec3_blog_detail_right_slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }
  ]
});


$('.sec3_cat_slider').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});


$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:'',
  nextArrow:'',
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  focusOnSelect: true,
  verticalSwiping:true,
});



$('.sec3_prod_slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000,
  centerMode: true,
  centerPadding: '180px',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2,
        centerPadding: '80px',
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        centerPadding: '30px',
      }
    }
  ]
});


function OpenLi(clickedID) {
	var elementid = document.getElementById(clickedID);
	let str = clickedID;
	str = str.substring(1);
	// alert(str);
	// if ("NavItem1" == clickedID) {
	var Imgid = document.getElementById(str);
	Imgid.style.width = "320px";
	Imgid.style.left = "0";
	abc = Imgid;
	// }
}

function backtoNav() {
	var ccc = abc;
	ccc.style.width = "0";
	ccc.style.left = "-100px";

}





